import React, { Component } from 'react';
import mobileVerify from '../../verification/mobile-verify.js';

class AccountSettingsMobileError extends Component {
	componentWillMount() {
		mobileVerify().open('error');
	}

	render() {
		return (
			<div id="account-verify-mobile-error" />
		);
	}
}

export default AccountSettingsMobileError;




// WEBPACK FOOTER //
// ./mobile-core/src/components/account/account-settings-mobile-error.js